/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/date_extract.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Extracts parts of a date, like year, month, day, hour.
 *
 * @example
 * ROW date = DATE_PARSE("yyyy-MM-dd", "2022-05-06")
 * | EVAL year = DATE_EXTRACT("year", date)
 *
 * @example
 * FROM sample_data
 * | WHERE DATE_EXTRACT("hour_of_day", @timestamp) < 9
 *     AND DATE_EXTRACT("hour_of_day", @timestamp) >= 17
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'date_extract',
  signatures: [
    {
      params: [
        {
          name: 'datePart',
          type: 'keyword',
          optional: false,
        },
        {
          name: 'date',
          type: 'date',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'long',
    },
    {
      params: [
        {
          name: 'datePart',
          type: 'keyword',
          optional: false,
        },
        {
          name: 'date',
          type: 'date_nanos',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'long',
    },
    {
      params: [
        {
          name: 'datePart',
          type: 'text',
          optional: false,
        },
        {
          name: 'date',
          type: 'date',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'long',
    },
    {
      params: [
        {
          name: 'datePart',
          type: 'text',
          optional: false,
        },
        {
          name: 'date',
          type: 'date_nanos',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'long',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
